import { render, staticRenderFns } from "./Expander.vue?vue&type=template&id=28c1c36d&"
import script from "./Expander.vue?vue&type=script&lang=js&"
export * from "./Expander.vue?vue&type=script&lang=js&"
import style0 from "./Expander.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports